import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative w-full h-[80vh] min-h-[600px] max-h-[900px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-[8000ms]"
        style={{
          backgroundImage: "url('https://readdy.ai/api/search-image?query=dramatic%20dark%20whisky%20distillery%20interior%20copper%20pot%20stills%20golden%20amber%20light%20rays%20atmospheric%20moody%20photography%20premium%20spirits%20luxury%20Scottish%20distillery%20barrels%20aged%20oak%20cinematic&width=1600&height=900&seq=hero-main&orientation=landscape')",
          transform: visible ? 'scale(1)' : 'scale(1.04)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40" />

      <div
        className={`relative z-10 flex flex-col items-start justify-center h-full px-8 md:px-16 lg:px-28 xl:px-36 max-w-4xl transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <p className="text-[#c9a84c] text-xs tracking-[0.35em] uppercase mb-5 font-medium">
          {t('hero_tagline')}
        </p>
        <h1
          className="text-4xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {t('hero_title_1')}<br />
          <span className="text-[#c9a84c]">{t('hero_title_2')}</span>
        </h1>
        <p className="text-white/60 text-sm md:text-base font-light mb-10 max-w-md leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/loja"
            className="bg-[#c9a84c] hover:bg-[#b8963e] text-black text-xs tracking-[0.2em] uppercase font-bold px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            {t('hero_cta_buy')}
          </Link>
          <Link
            to="/whiskies"
            className="border border-white/30 hover:border-[#c9a84c] text-white hover:text-[#c9a84c] text-xs tracking-[0.2em] uppercase font-medium px-8 py-4 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            {t('hero_cta_whiskies')}
          </Link>
        </div>

        <div className="flex gap-8 mt-14 pt-10 border-t border-white/10">
          <div>
            <p className="text-[#c9a84c] text-lg font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Islay</p>
            <p className="text-white/40 text-[10px] tracking-widest uppercase mt-1">{t('hero_islay_sub')}</p>
          </div>
          <div className="w-px bg-white/10" />
          <div>
            <p className="text-[#c9a84c] text-lg font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Speyside</p>
            <p className="text-white/40 text-[10px] tracking-widest uppercase mt-1">{t('hero_speyside_sub')}</p>
          </div>
          <div className="w-px bg-white/10" />
          <div>
            <p className="text-[#c9a84c] text-lg font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Highlands</p>
            <p className="text-white/40 text-[10px] tracking-widest uppercase mt-1">{t('hero_highlands_sub')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
